/* global axios */

import ApiClient from './ApiClient';

class DatabaseImportAPI extends ApiClient {
  constructor() {
    super('database_imports', { accountScoped: true });
  }

  create(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 600000,
    });
  }

  getProgress(progressKey) {
    return axios.get(`${this.url}/${progressKey}`);
  }

  resetData() {
    return axios.post(`${this.url}/reset_data`);
  }
}

export default new DatabaseImportAPI();
